'use client'

import { ButtonWrapper } from '../ButtonWrapper';
import { useRouter, useParams } from 'next/navigation';
import { sendEventToGTM } from '@/helpers/gtm.helper';
import { getDefaultLocale } from '@/config/app.config';

const BuyNowCTA = ({
    id,
    brand,
    title,
    price,
    businessUnitCode,
    ...props
}:{
    id?: string;
    brand?: string;
    title?: string;
    price?: string;
    link?: string;
    btn?: {
        variant?: string;
        size?: string;
        label?: string;
        target?: string;
    };
    businessUnitCode?: string;
}) => {
    const router = useRouter();
    const params = useParams();
    const locale = params?.locale as string;
    const defaultLocale = getDefaultLocale();

    const getLocalizedLink = (link: string) => {
        if (!link) return link;
        // If link is already locale-prefixed or is external, use as-is
        if (link.startsWith('http') || link.startsWith('//') || link.startsWith('tel:') || link.startsWith('mailto:')) {
            return link;
        }
        // Add locale prefix if not default locale
        if (locale && locale !== defaultLocale && !link.includes(`/${locale}/`)) {
            return `/${locale}${link.startsWith('/') ? link : `/${link}`}`;
        }
        return link;
    };

    return (
        <ButtonWrapper
            action={() => {
                if(props?.link) {
                    if (props?.link) {
                        if (props?.btn?.target === "_blank") {
                            window.open(props?.link, "_blank", "noopener, noreferrer");
                        } else {
                            router.push(getLocalizedLink(props?.link)); // using useRouter()
                        }
                    }
                }
            }}
            variant={props?.btn?.variant}
            size={props?.btn?.size}
            className="flex gap-0.5 items-center"
            value={<>{props?.btn?.label || "Buy Now"}</>}
            targetBlank={true}
            GTMEnabled={true}
            GTMPayload={
                {
                    productId: id,
                    component: "ProductCard",
                    componentId: "product_card",
                    productBrand: brand || "",
                    productTitle: title || "",
                    productPrice: price || "",
                    productUrl: props?.link,
                    businessUnitCode: businessUnitCode || "",
                    location: "Product Card",
                    label: props?.btn?.label || "Buy Now",
                    linkUrl: props?.link
                }
            }
        />
    )
}

export default BuyNowCTA;